export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "comparison_previous_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mois précédent"])},
        "comparison_previous_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Période précédente"])},
        "comparison_previous_week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Semaine précédente"])},
        "comparison_previous_year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Année précédente"])}
      },
      "en": {
        "comparison_previous_month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous month"])},
        "comparison_previous_period": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous period"])},
        "comparison_previous_week": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous week"])},
        "comparison_previous_year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Previous year"])}
      }
    }
  })
}
